<template>
    <div @mouseover="enter" @mouseleave="leave" id="head">
        <a :href="link" target="_blank" @click="leave">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5 45.5">
                <title>Flickr</title>
                <circle id="FlickrRing" cx="22.75" cy="22.75" r="22"/>
                <path id="FlickrLogoLeft" d="M36,25a4.91,4.91,0,0,1-4.8,5,4.85,4.85,0,0,1-4.8-5A4.8,4.8,0,1,1,36,25" transform="translate(-2.25 -2.25)"/>
                <path id="FlickrLogoRight" d="M23.7,25a4.91,4.91,0,0,1-4.8,5,4.85,4.85,0,0,1-4.8-5,4.91,4.91,0,0,1,4.8-5,4.91,4.91,0,0,1,4.8,5" transform="translate(-2.25 -2.25)"/>
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        link: String,
        darkMode: Boolean
    },
    methods: {
        enter: function () {
            document.getElementById("FlickrRing").style.stroke = "#575757";
            document.getElementById("FlickrRing").style.fill = "#F5F5F5";

            document.getElementById("FlickrLogoLeft").style.fill = "#0563DB";
            document.getElementById("FlickrLogoRight").style.fill = "#FF0084";
        },
        leave: function () {
            document.getElementById("FlickrRing").style.stroke = this.darkMode ? "#000000" : "#FFFFFF";
            document.getElementById("FlickrRing").style.fill = "none";

            document.getElementById("FlickrLogoLeft").style.fill = this.darkMode ? "#000000" : "#FFFFFF";
            document.getElementById("FlickrLogoRight").style.fill = this.darkMode ? "#000000" : "#FFFFFF";
        }
    },
    mounted() {
        // set light mode attributes, icon dark by default
        if (!this.darkMode) {
            document.getElementById("FlickrRing").style.stroke = "#FFFFFF";
            document.getElementById("FlickrLogoLeft").style.fill = "#FFFFFF";
            document.getElementById("FlickrLogoRight").style.fill = "#FFFFFF";
        }
    }
}
</script>

<style scoped>
#head {
    height: 45px;
    width: 45px;
    /* margin-right: 10px; */
    /* margin-bottom: 10px; */
}
#FlickrRing {
    fill: none;
    stroke:#000;
    stroke-width: 1.5px;
}
.FlickrDots {
    fill-rule: evenodd;
}
svg {
    width: 45px;
    position: absolute;
}
</style>